require('@fancyapps/fancybox');
import 'slick-carousel/slick/slick.min.js';
var imagesLoaded = require('imagesloaded');
import objectFitImages from 'object-fit-images';
export default {
  init() {
    // JavaScript to be fired on all pages

    //var small_breakpoint = 350;
    //var tablet_breakpoint = 850;
    //var desktop_breakpoint = 1250;

    //////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////////////// - menu
    //////////////////////////////////////////////////////////////////////////////////

    var $hamburger = $('#menu-hamburger');
    $hamburger.on('click', function (e) {
      e.preventDefault();
      $hamburger.toggleClass('is-active');
    });

    var $jsoverlay = $('.js-off-canvas-overlay');
    $jsoverlay.on('click', function (e) {
      e.preventDefault();
      $hamburger.removeClass('is-active');
    });

    $(document).on('facetwp-loaded', function() {
      if (FWP.loaded) {
        $(document).foundation();
      }
    });

    $(document).on('facetwp-refresh', function() {
      $(document).foundation();
    });

    objectFitImages('.slide img');

    if ($('#top_slider .slide').length > 1) {

      $('#top_slider').on('init', function (event, slick) {


      });

      $('#top_slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {

      });

      $('#top_slider').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        accessibility: true,
        adaptiveHeight: false,
        infinite: true,
        fade: true,
        speed: 1200,
        pauseOnHover: false,
        pauseOnFocus: false,
        waitForAnimate: false,
        nextArrow: '<span class="lnr lnr-chevron-right slide-arrow-right"></span>',
        prevArrow: '<span class="lnr lnr-chevron-left slide-arrow-left"></span>',
      });



    }
    else if ($('#top_slider .slide').length) {

      //for single-slide
      $('#top_slider').imagesLoaded(function () {
        $('#top_slider').addClass('slick-initialized');
      });



    }

    $('#top_slider').imagesLoaded().progress(function (instance, image) {

      var result = image.isLoaded ? 'loaded' : 'broken';
      if (result == 'loaded') {
        //console.log(image);
        $(image.img).parents('div').addClass('imageloaded');
      }

    });


    function new_location(href) {
      // alert('going somewhere?');
      // do special/fade stuff?
      window.location.href = href;
  }
  

    $('body').on('click', '.block', function(e) {
      //alert('clicked');
      e.preventDefault();
      e.stopPropagation();
      var href = $(this).find('a').first().attr('href');
      new_location(href);
  });



  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js